import { PrismicRichText } from '@prismicio/react'

import linkResolver from '@lib/prismic/link-resolver'
import htmlSerializer from '@lib/prismic/serializer'
import type { RichTextField } from '@prismicio/client'

function RichTextSerializer({ content }: { content: RichTextField | undefined }) {
	return (
		<PrismicRichText field={content} linkResolver={linkResolver} components={htmlSerializer} />
	)
}

export default RichTextSerializer
